import React, { useState } from 'react';
import { Settings, LogOut } from 'lucide-react';
import { APP_CONST } from '../../constants';
import { GeckoAlert, GeckoBtn, GeckoCardWrapper, GeckoCardBody, GeckoCardFooter } from '../../components';
import { $state, $stateParams } from '../../router';
import { Auth, ClientManager } from '../../services';
import ProfileSelector from '../../components/ProfileSelector';
import ErrorTracker from '../../services/ErrorTracker';


const SelectProfile = (props) => {
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const client = ClientManager.client() || 'web';
    const app = ClientManager.app();

    const enableAutoRedirect = ($stateParams.ar && $stateParams.ar === 'false' ? false : true);

    const onSelectProfile = (profile) => {
        if (!profile) {
            throw new Error('Expected ProfileId');
        }

        return Auth.getRedirectUrl(profile.ProfileId, client, app).then((response) => {
            redirect(response.RedirectUrl);
        }).catch((err) => {
            if (err instanceof Error) {
                ErrorTracker.captureException(err);
                setError(err.message);
            } else if (err.Error) {
                ErrorTracker.captureException(err.Error);
                setError(err.Error);
            } else {
                ErrorTracker.captureException(err);
                setError(err);
            }
        });
    }

    if (error) {
        return (
            <div>
                <GeckoAlert type={APP_CONST.ALERT_TYPE_DANGER}>
                    {error}
                </GeckoAlert>
            </div>
        );
    }

    return(
        <div id="module-select-profile" className="w-full">
            <GeckoCardWrapper>
                <GeckoCardBody>
                    <ProfileSelector 
                        client={client} 
                        app={app} 
                        onSelectProfile={onSelectProfile} 
                        autoRedirect={enableAutoRedirect}
                        onError={(err) => {
                            setError(err.message);
                        }}
                        onLoadingChange={setIsLoading}
                    />
                </GeckoCardBody>
                {!isLoading && (
                    <GeckoCardFooter>
                        <div className="flex flex-row gap-2 ">
                            <GeckoBtn
                                name="Security preferences"
                                icon={Settings}
                                type={APP_CONST.BTN_TYPE_OUTLINE}
                                className="w-full flex-1"
                                handler={() => {
                                    window.location.href = '/account';
                                }}
                            />
                            <GeckoBtn
                                name="Logout"
                                icon={LogOut}
                                type={APP_CONST.BTN_TYPE_OUTLINE}
                                className="w-full flex-1"
                                handler={() => {
                                    $state.go('logout', {
                                        client: ClientManager.client(),
                                        app: ClientManager.app(),
                                    });
                                }}
                            />
                        </div>
                    </GeckoCardFooter>
                )}
            </GeckoCardWrapper>
        </div>
    );

}

const redirect = (redirectUrl) => {
    if (!redirectUrl) {
        throw new Error('Redirect url not found');
    }

    window.location = redirectUrl;
}

export default SelectProfile;
